module.exports = __webpack_public_path__ + "static/play.bff8265c.png";


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/resources/images/play.png
// module id = 228
// module chunks = 0